"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetSubMenuCssClass = exports.AdjustItemInTree = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AdjustItemInTree = _ref => {
  let {
    branch,
    treeLevel = 0,
    treePosition,
    propertyToAdjust,
    setAllParentValues,
    value
  } = _ref;
  const trackedItem = branch[treePosition[treeLevel]];
  const setItemValue = () => {
    const propType = typeof trackedItem[propertyToAdjust];
    if (propType === 'boolean') {
      trackedItem[propertyToAdjust] = !trackedItem[propertyToAdjust];
    }
    if (propType === 'string' || propType === 'undefined') {
      trackedItem[propertyToAdjust] = value;
    }
  };
  if (treeLevel === treePosition.length - 1) {
    // Menu item found
    if (!setAllParentValues) {
      setItemValue();
    }
    return;
  }
  if (setAllParentValues) {
    setItemValue();
  }
  AdjustItemInTree({
    branch: branch[treePosition[treeLevel]].menuItems,
    treePosition,
    propertyToAdjust,
    setAllParentValues,
    value,
    treeLevel: treeLevel + 1
  });
};
exports.AdjustItemInTree = AdjustItemInTree;
const GetSubMenuCssClass = _ref2 => {
  let {
    level,
    subMenuItem,
    subMenuIsOpen
  } = _ref2;
  const {
    isOpen,
    menuItems,
    customCssClass
  } = subMenuItem;
  const cssClasses = ['subMenu', "level_".concat(level)];
  if (customCssClass) {
    cssClasses.push(customCssClass);
  }
  if (menuItems && menuItems.length > 0) {
    cssClasses.push('hasSubmenu');
    if (subMenuIsOpen || isOpen) {
      cssClasses.push('open');
    } else {
      cssClasses.push('closed');
    }
  }
  return cssClasses.join(' ');
};
exports.GetSubMenuCssClass = GetSubMenuCssClass;